// extracted by mini-css-extract-plugin
export var bottomWave = "bc_cW";
export var container = "bc_h";
export var middleWave = "bc_cV";
export var section = "bc_j";
export var subtitle = "bc_cq";
export var text = "bc_cl";
export var textContainer = "bc_bV";
export var title = "bc_d";